<script>
import Layout from "@/router/layouts/main";
import Banners from "@/components/widgets/banners";
import ReferralLink from "@/components/ReferralLink";
import HomeSummaryCards from "@/components/home/HomeSummaryCards";
import HomeExperiences from "@/components/home/HomeExperiences";
import HomeReferrals from "@/components/home/HomeReferrals";
import HomeShortcuts from "@/components/home/HomeShortcuts";
import HomeVouchers from "@/components/home/HomeVouchers";
import HomeSupport from "@/components/home/HomeSupport";
import HomeLatestClients from "@/components/home/HomeLatestClients";

// Home: cada bloco busca seus próprios dados e trata falhas isoladamente
export default {
  components: {
    Layout,
    Banners,
    ReferralLink,
    HomeSummaryCards,
    HomeExperiences,
    HomeReferrals,
    HomeShortcuts,
    HomeVouchers,
    HomeSupport,
    HomeLatestClients,
  },
};
</script>

<template>
  <Layout>
    <Banners></Banners>

    <HomeSummaryCards></HomeSummaryCards>

    <div class="row">
      <div class="col-12 col-lg-8">
        <ReferralLink></ReferralLink>
        <HomeExperiences></HomeExperiences>
        <HomeReferrals></HomeReferrals>
      </div>
      <div class="col-12 col-lg-4">
        <HomeShortcuts></HomeShortcuts>
        <HomeVouchers></HomeVouchers>
        <HomeSupport></HomeSupport>
        <HomeLatestClients></HomeLatestClients>
      </div>
    </div>
  </Layout>
</template>
